import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { AUTH_PETICION_REFRESH, AUTH_PETICIONES_NO_AUTH } from './config';
import { Router } from '@angular/router';
import { PETICIONES } from '../utils/constants';
import { catchError, switchMap, finalize, filter, take } from 'rxjs/operators';

/**
 * https://www.intertech.com/Blog/angular-4-tutorial-handling-refresh-token-with-new-httpinterceptor/
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private authService: AuthenticationService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addToken(request);
    return next.handle(request)
      // .do((event: HttpEvent<any>) => event)
      .pipe(catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if(err.status === 401 && request.url === PETICIONES.login.login){
            
          }
          else if (err.status === 401 && request.url !== AUTH_PETICION_REFRESH) {
            return this.handleUnauthorized(request, next);
          } else if (err.status === 401 && request.url === AUTH_PETICION_REFRESH) {
            this.authService.doLogout();
            this.router.navigate(['/internal/acces']);
          }
          return throwError(err);
        }
      }));
  }

  handleUnauthorized(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      return this.authService.doRefresh().pipe(
        switchMap((newToken: any) => {
          if (newToken != null) {
            this.authService.changeTokens(newToken);
            this.tokenSubject.next(newToken.accessToken);
            return next.handle(this.addToken(request));
          }

          // If we don't get a new token, we are in trouble so logout.
          this.router.navigate(['/internal/acces']);
          return this.authService.doLogout();
        }),
        catchError((err: any) => {
          console.log(err);
          // If there is an exception calling 'refreshToken', bad news so logout.
          this.authService.doLogout();
          //this.router.navigate(['/internal/acces']);
          this.router.navigate(['/external/passarela/acces']);
          return throwError(err);
        }),
        finalize(() => {
          this.isRefreshingToken = false;
        }));
    } else {
      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.addToken(request));
        }));
    }

  }

  /**
   * Añade el token a la cabecera de la petición si fuera necesario
   * @param request Petición interceptada
   * @returns Petición resultante
   */
  addToken(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.getToken(request.url);
    if (token != null) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }
    return request;
  }

  /**
   * Obtiene el token a enviar en la cabecera
   * @param url Url de la petición
   * @returns Token de acceso, de refresco o null (para las llamadas sin autorización)
   */
  getToken(url: string): string {
    let token;
    if (url.match(AUTH_PETICION_REFRESH)) {
      token = this.authService.getRefreshToken();
    } else {
      for (let index = 0; index < AUTH_PETICIONES_NO_AUTH.length; index++) {
        const element = AUTH_PETICIONES_NO_AUTH[index];
        // if (url.match(element)) {
        if (this.beginsWith(element, url)) {
          token = null;
          break;
        }
      }
    }
    if (token !== null && token === undefined) {
      token = this.authService.getAccessToken();
    }
    return token;
  }

  private beginsWith = function(partial, full){
    return (full.substr(0, partial.length) == partial);
  }
}
